// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kXFc","colBig":"styles_colBig__RmMh4","colSmall":"styles_colSmall__3X3Xy","shopifyNameWrapper":"styles_shopifyNameWrapper__13-nA"};